import ProductImageViewer from './product-image-viewer'
import ProductCallToActions from './product-ctas';
import ProductRfqForm from './product-rfq';
import SupplierMultiSelect from './supplier-multi-select';
import ProductEmailSupplierForm from "./product-email";
import ProductDetailTracking from './product-detail-tracking';
import SupplierDescription from './supplier-description';
import ProductSpecs from './product-specs';
import DatasheetSummary from "./datasheet-summary";

$(() => {
  new ProductImageViewer()
  new ProductCallToActions()
  new ProductRfqForm()
  new ProductEmailSupplierForm()
  new SupplierMultiSelect($("#rfq-dialog .multi-select")[0])
  new SupplierMultiSelect($("#email-supplier-dialog .multi-select")[0])
  new ProductDetailTracking()
  new SupplierDescription()
  new ProductSpecs()
  new DatasheetSummary()

  // @ts-ignore
  s.ActivityMap.regionIDAttribute = "class";
})